export class CheckIngestionPipelineAccessResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "ingestionPipelines",
            "baseName": "ingestionPipelines",
            "type": "Array<IngestionPipelineAccess>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CheckIngestionPipelineAccessResponse.attributeTypeMap;
    }
    constructor() {
    }
}
